import type { Catalog, Stream } from "./types";

/**
 * Find the catch-up counterpart of a live channel.
 *
 * The two sides of a channel arrive from the panel as separate streams with
 * separate ids, joined only by a shared `epg_channel_id`. A favourite is
 * stored as one `stream_kind='live'` row carrying the catch-up id alongside,
 * so this mapping is what makes "watch from the start" work later. Get it
 * wrong and the favourite silently points at another channel's archive.
 *
 * Lives apart from `favorites.ts` so it can be tested — that module pulls in
 * Dexie and the HTTP client, neither of which exists outside a browser.
 */
export function deriveCatchupStreamId(
  catalog: Catalog | null,
  liveStream: Stream,
): string | null {
  if (!catalog) return null;
  // A channel without an archive has no counterpart to find.
  if (!liveStream.tv_archive) return null;
  const epgId = liveStream.epg_channel_id;
  if (!epgId) return null;
  const match = catalog.catchup.streams.find((s) => s.epg_channel_id === epgId);
  return match ? match.id : null;
}
